import React from 'react'
import { TableRow, TableCell, IconButton, Box } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

function MyTableExpandableRow({ children, expandComponent, isExpanded, onToggle, totalColumns, ...otherProps }) {
  const colSpan = totalColumns + 1 ?? React.Children.count(children) + 1

  return (
    <>
      <TableRow {...otherProps}>
        <TableCell padding='checkbox'>
          <IconButton onClick={onToggle} aria-expanded={isExpanded}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {children}
      </TableRow>

      {isExpanded && (
        <TableRow>
          <TableCell padding='checkbox' />
          <TableCell colSpan={colSpan} style={{ padding: 8 }}>
            <Box
              sx={{
                width: '100%',
                boxSizing: 'border-box',
                padding: 1
              }}
            >
              <Box
                sx={{
                  maxWidth: '100%',
                  '& > div': { margin: '0 auto 0 0 !important' }
                }}
              >
                {expandComponent}
              </Box>
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default MyTableExpandableRow
